import { local } from '@/local';
import Store from '@/store/index';
import Vue from 'vue';

const mixins = {
  methods: {},
  properties: {
    local,
    appLoader: {
      start() {
        Store.dispatch('GlobalModule/updateAppLoader', { visibility: true });
      },
      end() {
        Store.dispatch('GlobalModule/updateAppLoader', { visibility: false });
      },
      error() {
        Store.dispatch('GlobalModule/updateAppLoader', { visibility: false });
      },
    },
    overlayLoader: {
      start() {
        Store.dispatch('GlobalModule/updateOverlayLoader', { visibility: true });
      },
      end() {
        Store.dispatch('GlobalModule/updateOverlayLoader', { visibility: false });
      },
      error() {
        Store.dispatch('GlobalModule/updateOverlayLoader', { visibility: false });
      },
    },
  },
};

Object.keys(mixins.methods)
  .forEach((ptKey) => {
    Vue[`$${ptKey}`] = Vue.prototype[`$${ptKey}`] = mixins.methods[ptKey];
  });
Object.keys(mixins.properties)
  .forEach((ptKey) => {
    Vue[ptKey] = Vue.prototype[ptKey] = mixins.properties[ptKey];
  });

export default mixins;
